export default __webpack_public_path__ + "e5b3decf9033a3d55215e174bba43c59.svg";